import { render, staticRenderFns } from "./wasteExchangeMain.vue?vue&type=template&id=6c3ea6cb&scoped=true"
import script from "./wasteExchangeMain.vue?vue&type=script&lang=js"
export * from "./wasteExchangeMain.vue?vue&type=script&lang=js"
import style0 from "./wasteExchangeMain.vue?vue&type=style&index=0&id=6c3ea6cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ea6cb",
  null
  
)

export default component.exports